import { ga4Event } from "../../utils/analytics";

export type NotificationEventData = {
  type: string;
}

export const sendEventNotificationClick = (data: NotificationEventData) => {
  ga4Event({
    event: 'notification_click',
    event_category: data.type,
  });
}

export const sendEventNotificationCloseClick = (data: NotificationEventData) => {
  ga4Event({
    event: 'notification_close',
    event_category: data.type,
  });
}
